import React from "react";

import { useConditionText } from "../../ConditionBuilder/hooks/useConditionText";
import { useActionText } from "../../ConditionBuilder/hooks/useActionText";

import styles from "./styles.css";

const RuleRowText = ({ column, rule }) => {
    const actionLabel = useActionText(rule);
    const conditionLabel = useConditionText(rule);

    if (column === "condition") {
        return (
            <div className={styles.ruleCell}>
                <p>{conditionLabel}</p>
            </div>
        );
    }

    return (
        <div className={styles.ruleCell}>
            <p>{actionLabel}</p>
        </div>
    );
};

export default RuleRowText;
